import Layout from "../layout/Layout";
import LifestyleQuest from "../layout/LifestyleQuest";

const LifestyleQuestionnaire = () => {
  return (
    <Layout>
      <LifestyleQuest />
    </Layout>
  );
};

export default LifestyleQuestionnaire;
